// eslint-disable-next-line import/no-extraneous-dependencies
import fetch from 'isomorphic-unfetch'
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloLink
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { APIInfoLogger, APIErrorLogger } from '../loggerUtils'
import { getGraphQLServiceURL } from '../servicesUtils'
import { getInitialData } from '../handshake'
import { isProduction } from '../../config/connections'

let apiHeaders = null
const customLink = setContext(async () => {
  // get the authentication token from local storage if it exists
  const getHeaderDataFromSession = await getInitialData()

  apiHeaders = getHeaderDataFromSession
  const { AccessToken = '', routingKey } = getHeaderDataFromSession

  return {
    headers: {
      Authorization: `Bearer ${AccessToken}`,
      routingKey
    }
  }

  // return the headers to the context so httpLink can read them
  // return {
  //   headers: {
  //     ...headers
  //   }
  // }
})

const queryHttpLink = createHttpLink({
  uri: getGraphQLServiceURL({ service: 'query' }),
  fetch
})

const mutationHttpLink = createHttpLink({
  uri: getGraphQLServiceURL({ service: 'mutation' }),
  fetch
})

const addAppLogger = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    if (!isProduction) {
      // log the graphQL API success response for temporary
      APIInfoLogger(operation?.operationName, '200')
    }

    return response
  })
)
const errorLink = onError(
  ({ graphQLErrors, networkError, operation, response }) => {
    const { LogoutURL } = apiHeaders

    if (graphQLErrors && graphQLErrors[0]) {
      graphQLErrors.forEach(({ message }) => {
        // Log the if any graphQLErrors
        APIErrorLogger(
          operation?.operationName,
          operation?.variables,
          message,
          networkError?.statusCode,
          response,
          operation.getContext().headers
        )
      })
    }
    if (networkError) {
      // Log the if any networkError
      APIErrorLogger(
        operation?.operationName,
        operation?.variables,
        networkError,
        networkError?.statusCode
      )
      // Logout if any 401 errors from API
      if (typeof window !== 'undefined' && networkError?.statusCode === 401) {
        window.location.href = LogoutURL || ''
      }
    }
  }
)

const mutationLink = errorLink.concat(
  addAppLogger.concat(customLink.concat(mutationHttpLink))
)
const queryLink = errorLink.concat(
  addAppLogger.concat(customLink.concat(queryHttpLink))
)

export const client = new ApolloClient({
  link: ApolloLink.split(
    (operation) => operation.getContext().apiType === 'write',
    mutationLink,
    queryLink
  ),
  cache: new InMemoryCache(),
  connectToDevTools: !isProduction && true
})

export default client
